const ID_PLACEHOLDER = '{id}';
const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
export const compileKennoView = (view) => {
    const parts = view.template.split(ID_PLACEHOLDER);
    const expectedParts = view.entityType === null ? 1 : 2;
    if (parts.length !== expectedParts) {
        throw new Error(`Kenno view "${view.key}" must contain ${expectedParts === 1 ? 'no' : 'exactly one'} ${ID_PLACEHOLDER} placeholder, got ${parts.length - 1}.`);
    }
    const source = parts.map(escapeRegExp).join('(\\d+)');
    return {
        ...view,
        pattern: new RegExp(`^${source}$`),
    };
};
//# sourceMappingURL=compileKennoView.js.map